import {
    Component,
    OnInit,
    AfterViewInit
} from '@angular/core';
import {
    Constants
} from '../Services/Constants';
import {
    HTTPService
} from '../Services/http.service';
import {
    Observable
} from 'rxjs/Observable';
import {
    filter
} from '../App/search.pipe';
import {
    DatePipe
} from "@angular/common";
import {
    MySharedService
} from '../App/shared.service';
import {
    ActivatedRoute,
    Router
} from '@angular/router';

@Component({
    templateUrl: './AppViews/ClientView/clientview.html',
    styleUrls: ['./AppViews/ClientView/clientview.css']
})

export class clientViewComponent implements OnInit, AfterViewInit {

    constants: Constants;
    userDetail: any;
    active = true;
    filter: any = {
        'CustomerId': 0,
        'FromDate': null,
        'ToDate': null,
        'StatusId': 0,
        'TaskId': 0
    };
    addTaskCommentData: any = {
        TaskLogId: 0,
        TaskLocationId: 0,
        StatusId: 0,
        Comments: "",
        TaskDate: "",
        CreatedBy: "",
        AssignedTo: ""
    };
    getTaskLocationUrl: string;
    getMultiLocationTaskUrl: string;
    getCustomerLocationUrl: string;
    public showLoader = false;
    userData: any = [];
    taskStatusItems: any = [];
    multiLocationTaskList: any = [];
    taskCommentsList: any = [];
    isAddCommentsFormSubmitted: boolean;
    taskLocationList: any = [];
    documentRoute: any;
    InstallationReport: any;
    ImageUploadFile: any;
    reportFile: any;


    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe, private route: ActivatedRoute, private _route: Router) {

        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter.TeamId = "";
        this.getTaskLocationUrl = "LocationTask/GetTaskListForVendorView";
        this.getMultiLocationTaskUrl = "LocationTask/GetTaskForVendor";
        this.getCustomerLocationUrl = "CustomerLocation/GetCustomerLocation";

    }

    ngOnInit() {
        this.BindDropdownData();
        this.GetMultiTaskLocationData();
        this.GetLocationTaskList();
        console.log(this.userDetail);
    }

    ngAfterViewInit() {
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

    }

    BindDropdownData() {
        this.showLoader = true;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        //if(this.filter.TeamId==""){
        TeamId = 0

        //}
        // else{
        //     TeamId = this.filter.TeamId;
        // }
        this._httpService.ajaxPost('Users/GetUsersTeam', {
            "IsActive": this.constants.enumUserStatus["Active"],
            "Role": null,
            "Site": null,
            "Team": this.userDetail.TeamID,
            "UserId": UserId
        }).subscribe(
            data => {
                this.userData = data["Users"];
            },
            err => {
                this.showLoader = false;
                console.log("BindFilters Failed");
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = true;
                this._httpService.ajaxPost('Common/GetParameter', {
                    "ParameterTypeId": this.constants.enumParamterTypeName["TaskStatusType"]
                }).subscribe(
                    data => {
                        this.taskStatusItems = data["Parameter"];
                        this.taskStatusItems.sort(function (a, b) {
                            if (a.ParameterDescription.toLowerCase() < b.ParameterDescription.toLowerCase()) return -1;
                            if (a.ParameterDescription.toLowerCase() > b.ParameterDescription.toLowerCase()) return 1;
                            return 0;
                        })
                    },
                    err => {
                        this.showLoader = false;
                        console.log("GetParameter Failed with status: " + err.status);
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                        this.showLoader = false;

                    }
                );
            }
        );
    }

    GetMultiTaskLocationData() {
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        if (this.filter.TeamId == "") {
            //to handle executives case
            //  if(this.userDetail.RoleId==3){
            TeamId = 0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
        } else {
            TeamId = this.filter.TeamId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost(this.getMultiLocationTaskUrl, {
            "TaskId": 0,
            "CustomerId": 0,
            "FromDate": "",
            "ToDate": "",
            "StatusId": "",
            "LoggedInUser": UserId

        }).subscribe(
            data => {
                this.multiLocationTaskList = data["LocationTaskList"];

            },
            err => {
                this.showLoader = false;
                console.log("GetMultiLocationTaskList Failed with status: " + err.status);
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
                console.log(this.multiLocationTaskList);
            }
        );
    }

    GetLocationTaskList() {
        this.showLoader = true;
        console.log(this.filter);
        this._httpService.ajaxPost(this.getTaskLocationUrl, {
            "TaskId": this.filter.TaskId,
            "CustomerId": 0,
            "ProjectId": 0,
            "VendorId": this.userDetail.VendorId,
            "FromDate": null,
            "ToDate": null,
            "StatusId": this.filter.StatusId
        }).subscribe(
            data => {
                this.taskLocationList = data["LocationTaskList"];
                this.documentRoute = data["FilePath"];


            },
            err => {
                this.showLoader = false;
                console.log("GetLocationTaskData Failed with status: " + err.status);
            },
            () => {
                this.showLoader = false;
                console.log("TaskLocationList: ");
                console.log(this.taskLocationList);
                console.log(this.documentRoute);
            }
        );
    }

    ShowAddComments(item: any) {
        this.AddCommentsFormLoad();
        this.filter.TaskLocationId = item.TaskLocationId;
        this.GetTaskLocationComments(item.TaskLocationId);
    }

    public AddCommentsFormLoad() {
        $('#resetaddTaskCommentForm').trigger('click');
    }

    GetTaskLocationComments(TaskLocationId: any) {
        this.showLoader = true;
        this._httpService.ajaxPost('LocationTask/GetTaskCommentList', {
            "TaskLocationId": TaskLocationId
        }).subscribe(
            data => {
                this.taskCommentsList = data["CommentList"];
            },
            err => {
                this.showLoader = false;
                console.log("GetTaskLocationComments Failed");
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
                // console.log("Comments:");
                // console.log(this.taskCommentsList);
            }
        )
    }

    addUpdateTaskComments(objItem: any) {
        let TaskLocationId = objItem.TaskLocationId;
        this.showLoader = true;
        this._httpService.ajaxPost('LocationTask/AddUpdateTaskComment', objItem)
            .subscribe(
                data => {
                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        msg[0] = msg[0].toLowerCase();
                        this._sharedService.ShowMessage(data["Status"].Message);
                    } else {
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                    this.filter.TaskId = 0;
                    this.GetTaskLocationComments(TaskLocationId);
                    this.GetLocationTaskList();
                }
            );
    }

    public ResetAddComments(form: any) {
        form.reset();
        form.resetForm();

        setTimeout(() => {
            this.addTaskCommentData.Comments = "";
        })

        this.isAddCommentsFormSubmitted = false;
    }

    AddTaskComment(form: any) {
        this.isAddCommentsFormSubmitted = true;
        var dateNow = moment(new Date()).format('DD/MM/YYYY');
        if (form.form.valid) {
            let objItem: any = {};
            objItem.TaskLogId = this.addTaskCommentData.TaskLogId;
            objItem.TaskLocationId = this.filter.TaskLocationId;
            objItem.StatusId = this.addTaskCommentData.StatusId;
            objItem.Comments = this.addTaskCommentData.Comments;
            objItem.TaskDate = dateNow.toString();
            objItem.CreatedBy = this.userDetail.SiteUserId;
            objItem.AssignedTo = this.userDetail.SiteUserId;
            // console.log(objItem);
            this.addUpdateTaskComments(objItem);
            this.filter.TaskLocationId = 0;
            $('#showAddComments').modal('hide');

        }
    }

    public CancelShowComments() {
        $('#showAddComments').modal('hide');
    }

    openIRImage(item: any) {
        this.InstallationReport = item.InstallationReport;//JSON.parse(JSON.stringify(this.taskLocationList.filter((taskLocation) => taskLocation.TaskLocationId == item.TaskLocationId)[0].InstallationReport));
        var IRReport = this.documentRoute + this.InstallationReport;
        window.open(IRReport);
    }

    openImage(item: any) {
        this.ImageUploadFile = item.ImageUploadFile;//JSON.parse(JSON.stringify(this.taskLocationList.filter((taskLocation) => taskLocation.TaskLocationId == item.TaskLocationId)[0].ImageUploadFile));
        var ImageReport = this.documentRoute + this.ImageUploadFile;
        window.open(ImageReport);
    }

    ExportDataInExcel() {
        this.showLoader = true;

        this._httpService.ajaxPost('LocationTask/ExportStatusReport', {
            "TaskId": this.filter.TaskId,
            "TaskLocationId": 0,
            "VendorId": 0
        }).subscribe(
            data => {
                this.reportFile = data["ReportFile"];
                window.location.href = this.reportFile;
            },
            err => {
                console.log("Export Status Report Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                this.showLoader = false;
            });
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ClientView/clientview.component.ts
 **/